import { render, staticRenderFns } from "./AppMdlConsenso.vue?vue&type=template&id=6245133f&"
import script from "./AppMdlConsenso.vue?vue&type=script&lang=js&"
export * from "./AppMdlConsenso.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports